import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import api from '../../services/api'
import './LoginPage.css'

function OrganizationSignupPage() {
  const { token } = useParams()
  const [organization, setOrganization] = useState('')
  const [loadingInvite, setLoadingInvite] = useState(true)
  const [inviteError, setInviteError] = useState('')
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')
  const [saving, setSaving] = useState(false)
  const [done, setDone] = useState(false)

  useEffect(() => {
    let active = true
    api.get(`/api/auth/signup/${token}`)
      .then((response) => {
        if (!active) return
        setOrganization(response.data?.data?.organization || 'Organização')
      })
      .catch((err) => {
        if (!active) return
        setInviteError(err.response?.data?.message || 'Link de cadastro inválido')
      })
      .finally(() => {
        if (active) setLoadingInvite(false)
      })
    return () => {
      active = false
    }
  }, [token])

  const submit = async (event) => {
    event.preventDefault()
    setError('')
    if (password !== confirmPassword) {
      setError('As senhas não coincidem')
      return
    }
    setSaving(true)
    try {
      await api.post(`/api/auth/signup/${token}`, { name, email, phone, password })
      setDone(true)
    } catch (err) {
      setError(err.response?.data?.message || 'Não foi possível concluir o cadastro')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="login-page">
      <div className="login-shell">
        <div className="login-brand-panel" aria-hidden="true">
          <p className="login-brand-kicker">Cadastro</p>
          <h1 className="login-brand-title">{organization || 'Organização'}</h1>
          <p className="login-brand-copy">
            Sua conta entra nesta organização. O acesso ao sistema só é liberado depois que um administrador atribuir um grupo de acesso.
          </p>
        </div>

        <div className="login-container">
          {loadingInvite && (
            <div className="login-header">
              <Loader2 className="login-spinner" size={28} />
              <p>Abrindo o convite…</p>
            </div>
          )}

          {!loadingInvite && inviteError && (
            <div className="login-header">
              <h2>Link inválido</h2>
              <p>{inviteError}</p>
              <Link to="/login">Ir para o login</Link>
            </div>
          )}

          {!loadingInvite && !inviteError && done && (
            <div className="login-header">
              <p className="login-brand-mark">{organization}</p>
              <h2>Cadastro recebido</h2>
              <p>
                Sua conta foi criada nesta organização. Você só entra no ERP depois que alguém atribuir um grupo de acesso.
              </p>
              <Link to="/login" className="login-submit" style={{ marginTop: '1.25rem', textDecoration: 'none' }}>
                Ir para o login
              </Link>
            </div>
          )}

          {!loadingInvite && !inviteError && !done && (
            <>
              <div className="login-header">
                <p className="login-brand-mark">{organization}</p>
                <h2>Criar conta</h2>
                <p>Preencha seus dados para solicitar acesso</p>
              </div>
              <form onSubmit={submit} className="login-form" noValidate>
                {error && <p className="login-error">{error}</p>}
                <div className="login-form-group">
                  <label htmlFor="signup-name">Nome</label>
                  <input id="signup-name" value={name} onChange={(e) => setName(e.target.value)} required disabled={saving} />
                </div>
                <div className="login-form-group">
                  <label htmlFor="signup-email">E-mail</label>
                  <input id="signup-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" disabled={saving} />
                </div>
                <div className="login-form-group">
                  <label htmlFor="signup-phone">Telefone</label>
                  <input id="signup-phone" value={phone} onChange={(e) => setPhone(e.target.value)} autoComplete="tel" disabled={saving} />
                </div>
                <div className="login-form-group">
                  <label htmlFor="signup-password">Senha</label>
                  <input id="signup-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} autoComplete="new-password" disabled={saving} />
                </div>
                <div className="login-form-group">
                  <label htmlFor="signup-confirm">Confirmar senha</label>
                  <input id="signup-confirm" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required minLength={6} autoComplete="new-password" disabled={saving} />
                </div>
                <button type="submit" className="login-submit" disabled={saving}>
                  {saving ? 'Enviando…' : 'Cadastrar'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default OrganizationSignupPage
